var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    display: _vm.showSiderbar ? 'flex' : 'block',
  }),attrs:{"id":"home"}},[(_vm.showSiderbar)?_c('Sidebar'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }